'use client';

import LOCATION_PATHS from '@lingo/adobe-analytics';
import Script from 'next/script';
import { useRef } from 'react';
import useIsVisible from 'ui/components/hooks/useIsVisible';

export default function InstagramFeed({ data }) {
  const options = {
    root: null,
    rootMargin: '0px 0px 1500px 0px',
    threshold: 0,
  };
  const elemRef = useRef();
  const isVisible = useIsVisible(elemRef, options);

  const {
    title: { plaintext: postsTitleHtml = '' },
    text: { plaintext: postsTextHtml = '' },
    post1: { plaintext: post1Html = '' },
    post2: { plaintext: post2Html = '' },
    post3: { plaintext: post3Html = '' },
    post4: { plaintext: post4Html = '' },
  } = data;

  return (
    <section ref={elemRef} data-analytics-location={LOCATION_PATHS.pages.home.instagramFeed}>
      {isVisible && (
        <>
          <div
            className='instagram-feed grid-container mt-36 mb-24'
            data-analytics-location={LOCATION_PATHS.pages.home.instagramFeed}
          >
            <h3 className='col-span-4 md:col-span-6'>{postsTitleHtml}</h3>
            <div
              className='col-span-4 md:col-span-5 [&>p]:mb-6'
              dangerouslySetInnerHTML={{ __html: postsTextHtml }}
            />
          </div>
          <div className='grid-container mb-36'>
            <div
              className='col-span-4 md:col-span-6 lg:col-span-3 flex justify-center lg:col-start-3 xl:col-start-auto'
              dangerouslySetInnerHTML={{ __html: post1Html }}
            />
            <div
              className='col-span-4 md:col-span-6 lg:col-span-3 flex justify-center lg:col-start-8 xl:col-start-auto'
              dangerouslySetInnerHTML={{ __html: post2Html }}
            />
            <div
              className='col-span-4 md:col-span-6 lg:col-span-3 flex justify-center lg:col-start-3 xl:col-start-auto'
              dangerouslySetInnerHTML={{ __html: post3Html }}
            />
            <div
              className='col-span-4 md:col-span-6 lg:col-span-3 flex justify-center lg:col-start-8 xl:col-start-auto'
              dangerouslySetInnerHTML={{ __html: post4Html }}
            />
          </div>

          {/* This must be loaded after required instagram content is on a page */}
          <Script src='https://www.instagram.com/embed.js' />
        </>
      )}
    </section>
  );
}
